export const buildIframePreviewPath = (systemCode?: string, assetId?: string) => {
  if (!systemCode || !assetId) return "";
  return `/iframe/${systemCode}/${assetId}`;
};
